import React from 'react';
import { Link } from 'react-router-dom';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarToday from '@material-ui/icons/CalendarToday';
import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';

import style from './whsOrdersList.module.css'
import commonStyles from '../../common/common.module.css';

import OfflineOrderWhs from '../../../models/OfflineOrderWhs';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';

import moment, { Moment } from "moment";

const styles = (theme: Theme) =>

  createStyles({
    datePickerInput: {
      width: '160px',
      '& input': {
        padding: '0 0 0 15px',
        fontSize: '14px'
      }
    },
    grey: {
      color: 'grey'
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    green: {
      color: 'rgb(66, 183, 70)'
    }
  });

interface WhsOrdersListProps {
  classes: any;
  orders: OfflineOrderWhs[];
  orderDate: Moment;
  dateChange: (date: Moment) => void;
  type: string;
};

const whsOfflineOrdersList = (props: WhsOrdersListProps) => {

  const { classes, orders, type } = props;

  return (
    <div className={ style.wrapper }>
      <div className={ style.dataWrapper }>
        <span className={ style.dockText }>Dock activity</span>
        <KeyboardDatePicker
          autoOk
          format='DD MMM YYYY'
          value={ props.orderDate }
          onChange={(date: any) => props.dateChange(date) }
          InputProps={{ 
            className: classes.datePickerInput,
            disableUnderline: true
          }}
        />
      </div>

      <div className={ commonStyles.wrapper }>
        <h1 className={ commonStyles.header }>table</h1>

        <MaterialTable

          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
                    
          data={ orders } 

          columns={[
            { title: 'Order #', field: 'number', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'},
            render: (rowData: OfflineOrderWhs) => {
              return <Link to={`/whs/${type}/${rowData.id}-wh`} >{ rowData.rfs_number }</Link>;
            }
            },
            { title: 'ORG-DES', field: 'ord_dst', cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
            { title: 'Dept', field: 'dept', 
              render: (rowData: OfflineOrderWhs) => {
                let dept= (rowData.schedule_date)? moment(rowData.schedule_date).format('DD-MMM-YYYY').toUpperCase() : ''
                dept = dept + ' '+ moment(rowData.schedule_time).format('HH:mm');
                return dept;
              }, cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
            { title: 'Arrv', field: 'arrv', 
              render: (rowData: OfflineOrderWhs) => {
                let arrv= (rowData.arrival_date)? moment(rowData.arrival_date).format('DD-MMM-YYYY').toUpperCase() : ''
                arrv = arrv + ' '+ moment(rowData.arrival_time).format('HH:mm');
                return arrv;
            }, cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
            { title: 'Lock', field: 'lock_status',
              render: (rowData: OfflineOrderWhs) => {
          
                  if( rowData.lock_status !== OrderLockStatusType.UNLOCKED){
                    const color = rowData.lock_status === OrderLockStatusType.LOCKED ? `${classes.blue}`: `${classes.gray}`;
                    return (
                      <Lock className={ color }/>
                    )
                  }
                  return (
                    <LockOpen className={ classes.green } />
                  )
              }
              ,cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
          ]}

          options={{
            paging: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            pageSizeOptions: [15, 20],
            toolbar: false,
            sorting: false
          }}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(whsOfflineOrdersList);